export function checkValidPathname(pathname: string): { error?: string } {
  const rootPathName = pathname == ''
  if (rootPathName) return {};

  const pathnameStartsWithWpPrefix = pathname.startsWith('wp-')
  if (pathnameStartsWithWpPrefix) {
    return { error: 'Страницы начинающие с "wp-" не доступны' }
  }

  const pathnameStartsAdminWord = pathname.startsWith('admin')
  if (pathnameStartsAdminWord) {
    return { error: 'Страницы начинающие с "admin" не доступны' }
  }

  const pathnameIncludesOnlyEnglishLettersNumbersAndTire = (/^[a-z0-9-]*$/.test(pathname))
  if (!pathnameIncludesOnlyEnglishLettersNumbersAndTire) {
    return { error: 'В url могут быть только цифры, английские прописные буквы и тире' }
  }

  return {};
}
